import { Fragment } from 'react';
import styled from 'styled-components';
import ThematicAreaItem from './ThematicAreaItem';

function ThematicAreaDisplay({ thematicAreas, loading }) {
  let thematic_areas = thematicAreas?.thematicAreas || [];
  let total = thematicAreas?.total;
  return (
    <StyledHomeList>
      {loading ? (
        <div>loading...</div>
      ) : (
        <Fragment>
          <div className="content">
            {thematic_areas.map((thematicArea) => {
              let title = Object.keys(thematicArea)[0];
              let value = Object.values(thematicArea)[0];
              return <ThematicAreaItem key={title} title={title} count={value} total={total} />;
            })}
          </div>
        </Fragment>
      )}
    </StyledHomeList>
  );
}

export default ThematicAreaDisplay;

const StyledHomeList = styled.div`
  .content {
    height: 514px;
    overflow-y: auto;
    padding-right: 1rem;
  }
`;
